import "./App.css";
import Home from "./components/Home";
import { Routes, Route, Link } from "react-router-dom";
import Product from "./components/Product";
import Category from "./components/Category";
import Footer from "./components/Footer";
import NavBar from "./components/NavBar";
import RegisterLogin from "./components/RegisterLogin";
import ShoppingCart from "./components/ShoppingCart";
import Checkout from "./components/Checkout";
import AboutThisProject from "./components/AboutThisProject";
import UserProfile from "./components/UserProfile";
import MyOrders from "./components/MyOrders";
import AccountDetails from "./components/AccountDetails";
import Logout from "./components/Logout";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import NoMatch from "./components/NoMatch";
import Button from "react-bootstrap/Button";

function App() {
  return (
    <div className="App">
      <div className="flex-shrink-0">
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product/:slug" element={<Product />} />
            <Route path="/category/:id" element={<Category />} />
            <Route path="/login-register" element={<RegisterLogin />} />
            <Route path="/shoppingCart" element={<ShoppingCart />} />
            <Route path="/aboutUs" element={<AboutThisProject />} />

            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <UserProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile/orders"
              element={
                <ProtectedRoute>
                  <MyOrders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile/account-details"
              element={
                <ProtectedRoute>
                  <AccountDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile/logout"
              element={
                <ProtectedRoute>
                  <Logout />
                </ProtectedRoute>
              }
            />

            <Route
              path="/checkout"
              element={
                <ProtectedRoute>
                  {" "}
                  <Checkout />{" "}
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NoMatch />} />
          </Routes>
        </ScrollToTop>
      </div>
      <Footer />
      <Link to={"/aboutUs"}>
        <Button
          style={{ backgroundColor: "#7cb600" }}
          className="px-3 py-2 rounded-pill border-0 about"
        >
          About this project
        </Button>
      </Link>
    </div>
  );
}

export default App;
